var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeviceFinishing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.40201,
    y: 2.40201,
    width: 36.7538,
    height: 36.7538,
    rx: 11.1859,
    fill: "#00A79D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.40201,
    y: 2.40201,
    width: 36.7538,
    height: 36.7538,
    rx: 11.1859,
    stroke: "#F9F9F9",
    strokeWidth: 3.19598
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0405 18.6455L27.4425 17.8465C27.1469 17.7026 26.7793 17.8145 26.6355 18.1101C26.4837 18.4137 26.6036 18.7733 26.8992 18.9171L28.1696 19.5483V23.3755L25.1734 23.3835V15.1858C25.1734 13.5878 24.1027 12.7888 22.7764 12.7888H16.3844C15.0581 12.7888 13.9874 13.5878 13.9874 15.1858V28.1695H12.7889C12.4614 28.1695 12.1897 28.4411 12.1897 28.7687C12.1897 29.0963 12.4614 29.368 12.7889 29.368H26.3719C26.6994 29.368 26.9711 29.0963 26.9711 28.7687C26.9711 28.4411 26.6994 28.1695 26.3719 28.1695H25.1734V24.582L28.7688 24.574C29.1044 24.574 29.3681 24.3023 29.3681 23.9747V19.1808C29.3681 18.9571 29.2403 18.7493 29.0405 18.6455ZM15.9849 16.6959C15.9849 15.5853 16.6641 15.1858 17.495 15.1858H21.6738C22.4967 15.1858 23.1759 15.5853 23.1759 16.6959V17.6787C23.1759 18.7813 22.4967 19.1808 21.6658 19.1808H17.495C16.6641 19.1808 15.9849 18.7813 15.9849 17.6707V16.6959ZM16.3844 20.9785H18.7814C19.109 20.9785 19.3807 21.2502 19.3807 21.5778C19.3807 21.9054 19.109 22.177 18.7814 22.177H16.3844C16.0568 22.177 15.7852 21.9054 15.7852 21.5778C15.7852 21.2502 16.0568 20.9785 16.3844 20.9785Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceFinishing);
export default __webpack_public_path__ + "static/media/device-finishing.b44027524d18759daa301710e0e1b895.svg";
export { ForwardRef as ReactComponent };